<div class="row">
  <div class="col-12 mb-2">
    <table
      datatable
      [dtOptions]="dtOptions"
      [dtTrigger]="dtTrigger"
      class="table table-striped mb-0"
    >
      <thead>
        <tr>
          <td style="width: 5px">Id</td>
          <th style="width: 200px">Changed On</th>
          <th style="width: 500px">Changed By</th>
          <th style="width: 100px">Source</th>
          <th style="width: 100px">Card</th>
          <th style="width: 100px">Commission</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let commission of commissionDetails">
          <td style="font-size: 12px">{{ commission.id }}</td>
          <td style="font-size: 12px">
            {{ commission.changedOn | date: "MMM d, y, h:mm:ss a" }}
          </td>
          <td style="font-size: 12px">{{ commission.changedBy }}</td>
          <td style="font-size: 12px">{{ commission.source }}</td>
          <td style="font-size: 12px">{{ commission.cardId }}</td>
          <td style="font-size: 12px">{{ commission.commission }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
<div class="row">
  <div class="col-12">
    <div class="page-title-box">
      <div class="page-title-right">
        <input
          type="button"
          value="Print"
          class="btn btn-success"
          (click)="print()"
        />
        &nbsp;
        <input
          type="button"
          value="Export to CSV"
          class="btn btn-success"
          (click)="DownloadCsv()"
        />
      </div>
    </div>
  </div>
</div>
